// Libs
import React from 'react'
import classNames from 'classnames'

// CSS
import "./styles.scss"

// Constants
import { secureData } from '../../constants/others'

const Input = ({
  input,
  meta: {
    touched,
    error,
  },
  type,
  label,
  placeholder,
  capitalize,
  secured,
  disabled,
  gutter,
  autoComplete,
  handleBlur,
  handleDelete,
  handleEnter,
}) => {
  const inputStyle = {
    margin: `${gutter / 2}px 0px`,
  }

  const inputClassName = classNames(
    'input__input',
    {
      'input__input--error': touched && error,
      'input__input--capitalize': capitalize,
      'input__input--disabled': disabled,
    }
  )

  const onBlur = (e) => {
    input.onBlur(e)
    handleBlur && handleBlur(e.target.value)
  }

  const onKeyDown = (e) => {
    if (handleEnter && e.keyCode === 13) {
      handleEnter(e.target.value)

      e.preventDefault()
    }
  }

  return (
    <div style={inputStyle} className="input">
      <div className="input__label">{label}</div>
      <input
        {...input}
        type={type}
        value={disabled & secured ? secureData(input.value) : input.value}
        placeholder={placeholder}
        disabled={disabled}
        className={inputClassName}
        onBlur={onBlur}
        autoComplete={autoComplete}
        onKeyDown={onKeyDown} />
      {touched && error && <p className="input__error">{error}</p>}
    </div>
  )
}

export default Input
